module.exports = require("@wildboar/ldap/src/lib/stringifiers/RelativeDistinguishedName");